module.exports = __webpack_public_path__ + "img/changsha_center.eea2f426.jpg";